import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_URL, API_BOW_URL } from "./../config";


function getAuthData() {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) throw new Error("No access token found");

  const decoded = jwtDecode(accessToken);
  return {
    token: accessToken,
    id: decoded?.id,
    hospitalId: decoded?.hospitalId || null,
    roleId: decoded?.roleId || 1,
  };
}

// Auth
export const login = (payload) => {
  return axios.post(`${API_URL}/auth/login`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const loginBow = (payload) => {
  return axios.post(`${API_BOW_URL}/api/auth/login/`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const register = (payload) => {

  return axios.post(`${API_URL}/auth/register`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Users
export const getUser = () => {
  return axios.get(`${API_URL}/users`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getUserDetail = () => {
  const { hospitalId, id } = getAuthData();

  return axios.get(`${API_URL}/users/user/detail`, {
    params: {
      hospitalId,
      userId: id,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getUserById = (id) => {
  const { hospitalId } = getAuthData();

  return axios.get(`${API_URL}/users/user/detail`, {
    params: {
      hospitalId,
      userId: id,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const createUser = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${API_URL}/users`,
    { ...payload, shopId: shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const deleteUser = (id) => {
  const { hospitalId } = getAuthData();

  return axios.delete(`${API_URL}/users/${hospitalId}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const updateUser = (id, payload) => {
  const { hospitalId } = getAuthData();

  return axios.put(`${API_URL}/users/${hospitalId}/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const resetPassword = (username, password) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${API_URL}/users/reset_password/${shopId}`,
    { username, password },
    {
      headers: {
        "Content-Type": "application/json",
        // "Authorization": "Bearer " + token,
      },
    }
  );
};
export const getPetBowById = (id) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  console.log(id)
  return axios.get(`${API_BOW_URL}/api/pets/${id}?all=true`, {
    headers: {
      "Content-Type": "application/json",
      'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const getPetById = (id) => {
  return axios.get(`${API_URL}/pets/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const getPetHistoryById = (id) => {
  return axios.get(`${API_URL}/pet-treatment?id=${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};

export const createTreatments = (payload) => {
  // const BowAccessToken = localStorage.getItem("accessToken");
  return axios.post(`${API_URL}/pets`,payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const putVaccineRecordsBow = (payload) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  return axios.post(`${API_BOW_URL}/api/vaccine-records/`,payload, {
    headers: {
      "Content-Type": "application/json",
      'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
export const putMicrochipRecordsBow = (payload) => {
  const BowAccessToken = localStorage.getItem("bow_accessToken");
  return axios.patch(`${API_BOW_URL}/api/pets/${payload.id}/?all=true`,payload, {
    headers: {
      "Content-Type": "application/json",
      'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};

export const getHistory = () => {
  const { roleId ,id,hospitalId} = getAuthData();
  let query=""
  if(roleId ==1){
    query =`hospitalId=${hospitalId}`
  }else{
    query =`hospitalId=${hospitalId}&handledById=${id}`
  }
  return axios.get(`${API_URL}/pet-treatment?${query}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${API_URL}/files`,formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const getHospitalList = () => {
  return axios.get(`${API_URL}/users/hospital/list`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + BowAccessToken
    },
  });
};
